import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import stripeLogo from '@/assets/images/common/stripe-wordmark-blurple.png';

// ローディング表示
function LoadingForStripe(): ReactElement {
    const { t } = useTranslation('checkout');
    const text = 'Kotomil';

    return (
        <div className="h-screen w-screen flex flex-col justify-center items-center">
            <div className="flex justify-center items-center absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <div className="flex space-x-1 text-4xl md:text-5xl font-extrabold tracking-wider">
                    {text.split('').map((char, index) => (
                        <span
                            key={index}
                            className="animate-bounce bg-gradient-to-b from-kotomilThemaColorLight to-kotomilThemaColor bg-clip-text text-transparent"
                            style={{ animationDelay: `${index * 100}ms` }}
                        >
                            {char}
                        </span>
                    ))}
                </div>
            </div>
            <div className="pt-40 mx-8 flex flex-col justify-center items-center">
                <p className="text-2xl leading-[1.8] tracking-widest">{t('loading.hero')}</p>
                <p className="mt-10 text-lg leading-[1.8] tracking-widest">
                    {t('loading.description')}
                </p>
            </div>
            <div className="mt-10 flex justify-center items-center space-x-2">
                <p className="text-2xl leading-[1.8] tracking-widest">{t('loading.poweredBy')}</p>
                <img src={stripeLogo} alt="Stripe" className="w-44" />
            </div>
        </div>
    );
}

export default LoadingForStripe;
